export const ApiRoot = "/.netlify/functions/";